<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <el-input v-model="title" placeholder="标题" :maxlength="30" style="width: 100%"></el-input>

    <quill-editor class="mt20" ref="myQuillEditor" v-model="content" :options="editorOption" />
    <input ref="fileInput" class="file-input" @change="(e) => changeFile(e, 'img')" accept=".jpg,.jpeg,.png,.gif" type="file">

    <div class="mt20">
      上传视频：
      <div class="upload-wrap" v-if="!videoUrl">
        <el-button type="primary" size="small" icon="el-icon-upload">上传</el-button>
        <input @change="(e) => changeFile(e, 'video')" accept=".mp4,.ogg,.avi,.webm" type="file">
      </div>
      <video class="block-entry" v-if="videoUrl" :src="videoUrl" controls></video>
    </div>

    <div class="mt20">
      <el-button @click="$router.back()">返回</el-button>
      <el-button type="primary" @click="submit">保存</el-button>
    </div>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import Client from "@/utils/client.js"
import {
  creatOrUpdateQuestion,
  getQuestionDetail,
} from "@/api/faq";
import {
  fileUpload,
} from "../../api/mapping";

export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      fullscreenLoading: false,
      title: '',
      content: '',
      releaseStatus: 2,
      releaseDate: null,
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              // ['blockquote', 'code-block'],
              [{ 'header': 1 }, { 'header': 2 }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              // [{ 'script': 'sub' }, { 'script': 'super' }],
              // [{ 'indent': '-1' }, { 'indent': '+1' }],
              // [{ 'direction': 'rtl' }],
              // [{ 'size': ['small', false, 'large', 'huge'] }],
              // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'color': [] }, { 'background': [] }],
              // [{ 'font': [] }],
              [{ 'align': '' }, { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' }],
              ['clean'],
              ['image'], // 'link', 'video'
            ],
            handlers: {
              'image': this.imgHandler,
            }
          }
        },
        placeholder: '请输入内容',
        readOnly: Boolean(this.$route.params.sid),
      },
      videoUrl: '',
    };
  },
  computed: {
    inputEl() {
      return this.$refs.fileInput;
    },
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
    id() {
      return this.$route.params.id;
    },
    cid() {
      return this.$route.params.cid;
    },
  },
  mounted() {
    if (this.id) {
      getQuestionDetail(this.id).then(res => {
        if (res.data && res.data.data) {
          this.title = res.data.data.title;
          this.content = res.data.data.content;
          this.videoUrl = res.data.data.url;
        }
      })
    }
  },
  methods: {
    // onEditorBlur(quill) {
    //   console.log('editor blur!', quill)
    // },
    // onEditorFocus(quill) {
    //   console.log('editor focus!', quill)
    // },
    // onEditorReady(quill) {
    //   console.log('editor ready!', quill)
    // },
    // onEditorChange({ quill, html, text }) {
    //   console.log('editor change!', quill, html, text)
    //   this.content = html
    // }
    imgHandler() {
      this.inputEl.click();
    },
    async changeFile(e, type) {
      if (e && e.target && e.target.files && e.target.files[0]) {
        try {
          this.fullscreenLoading = true;
          const file = e.target.files[0];
          const confRes = await fileUpload();
          const OSSClient = Client(confRes.data.data);
          const objectKey = `tmp/${new Date().getTime()}${Math.random()}.${file.name.split('.').pop()}`;
          const ossRes = await OSSClient.put(objectKey, file);     
          const fileUrl = ossRes.res.requestUrls[0];
          if (type === 'img') {
            this.insertImg(fileUrl);
          } else {
            this.videoUrl = fileUrl;
          }
          this.fullscreenLoading = false;
        } catch (error) {
          this.fullscreenLoading = false;
          console.log(error);
          this.$message.error('上传失败，请稍后再试');
        }
      }
      e.target.value = '';
    },
    insertImg(fileUrl) {
      const pos = this.editor.getSelection().index;
      this.editor.insertEmbed(pos, 'image', fileUrl, { maxLength: '100%' });
    },
    submit() {
      if (!this.title) {
        this.$message('请输入标题');
        return;
      }
      creatOrUpdateQuestion({
        id: this.id,
        faqCategoryId: this.cid, //faq 分类id
        title: this.title,
        content: this.content,
        url: this.videoUrl,
      }).then(res => {
        if (res.data && res.data.status === 1) {
          this.$message.success('提交成功');
          this.$router.back();
        } else {
          this.$message.error(res.data.message || '系统异常');
        }
      })
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}

.tr {
  margin-top: 10px;
  text-align: right;
}

.ml10 {
  margin-left: 10px;
}

.mt20 {
  margin-top: 20px;
}

.file-input {
  display: none;
}

.title {
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
}
.date {
  margin-top: 6px;
  color: #CCCCCC;
  font-size: 13px;
  line-height: 18px;
}
.upload-wrap {
  position: relative;
  display: inline-block;
  margin-left: 10px;

  input {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 10;
  }
}
.block-entry {
  display: block;
  max-width: 100%;
  margin-top: 10px;
}
</style>
<style>
.preview-bulletin {
  margin-top: 27px;
  overflow: hidden;
  font-size: 13px;
  line-height: 24px;
  white-space:pre-wrap;
}
.preview-bulletin .ql-direction-rtl {
  direction: rtl;
  text-align: inherit;
}
.preview-bulletin .ql-align-center {
  text-align: center;
}
.preview-bulletin .ql-align-justify {
  text-align: justify;
}
.preview-bulletin .ql-align-right {
  text-align: right;
}
.preview-bulletin img {
  max-width: 100% !important;
}
.ql-editor {
  min-height: 400px;
}
.ql-toolbar.ql-snow {
  border-color: #DCDFE6;
  border-radius: 4px 4px 0 0;
}
.ql-container.ql-snow {
  border-color: #DCDFE6;
  border-radius: 0 0 4px 4px;
}
</style>
